import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { TemplatePicker } from "./TemplatePicker";

export function EmailDialog({ client, open, onOpenChange, onSent, templateVars }) {
  const [f, setF] = useState({ subject: "", body: "" });
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await api.post(`/clients/${client.id}/email`, f); toast.success("Email sent"); setF({ subject: "", body: "" }); onOpenChange(false); onSent?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="email-dialog">
        <DialogHeader><DialogTitle>Email {client.first_name}</DialogTitle></DialogHeader>
        <DialogDescription className="text-xs">To {client.email} · replies go to your clinic email (Settings → Contact)</DialogDescription>
        <div><TemplatePicker vars={templateVars || {}} testId="email-templates" onPick={(t) => setF({ subject: t.subject || f.subject, body: t.body })} /></div>
        <Input data-testid="email-subject" placeholder="Subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} />
        <Textarea rows={8} data-testid="email-body" placeholder="Your message" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} />
        <Button className="rounded-full" data-testid="email-send" disabled={busy || !f.subject.trim() || !f.body.trim()} onClick={send}>{busy ? "Sending…" : "Send email"}</Button>
      </DialogContent>
    </Dialog>
  );
}
